import React, { useState, useEffect } from "react";

const LinkModal = ({ open, onClose, onSave, initialValue = "" }) => {
  const [url, setUrl] = useState(initialValue);

  useEffect(() => {
    if (open) setUrl(initialValue);
  }, [open, initialValue]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-lg relative">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">
          Harici Link Ekle
        </h2>

        <input
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://örnek.com"
          className="w-full border border-gray-300 rounded-lg p-3 mb-4 focus:ring-2 focus:ring-blue-500 focus:outline-none"
        />

        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100"
            onClick={onClose}
          >
            İptal
          </button>
          <button
            className="px-4 py-2 rounded-full bg-[#07183c] text-white hover:bg-[#0b2155]"
            onClick={() => {
              if (url.trim()) {
                onSave(url.trim());
                onClose();
              }
            }}
          >
            Kaydet
          </button>
        </div>
      </div>
    </div>
  );
};

export default LinkModal;
